import React from 'react';
import { AuditTab } from 'areas/shared/components';

class AuditInfoTab extends React.Component {
    
    render() {
        let opts = {
            entityType: "DISCOUNT_CODE",
            tabKey: this.props.tabKey,
            active: this.props.active,
            helpKey: this.props.helpKey,
            selectedId: this.props.selectedId,
            title: this.props.title
        };

        return (
            <React.Fragment>
                <AuditTab {...opts} />
            </React.Fragment>
        );
    }
}

export default AuditInfoTab;


// WEBPACK FOOTER //
// ./src/areas/admin/discountCodeSetup/auditInfo/AuditInfoTab.js